import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="ankurit-footer">
      <div className="ankurit-footer__inner">
        <a href="/" className="ankurit-footer__brand">Ankurit</a>
        <nav className="ankurit-footer__links" aria-label="Footer">
          <a href="/products">Products</a>
          <a href="/explore">Explore</a>
          <a href="/support">Support</a>
          <a href="/legal-privacy">Legal</a>
        </nav>
        <p>&copy; {new Date().getFullYear()} Ankurit. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
